import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import CorrespondenceFieldInput from './CorrespondenceFieldInput'

const FieldSectionCode = (props) => {
    const t = useTranslate();
    const [inputValue,setInputValue] = useState({
        value1:'',
        value2:''
    })

    const [timer,setTimer]=useState({});
    const [currentTimer,setCurrentTimer]=useState(false);

    useEffect(function () {
        if(props.index==0)  setInputValue({...inputValue,value1:t('defaultValue')})
    }, [])

    useEffect(function () {
        if(Object.keys(props.correspondenceField).length!=0){
            const key = Object.keys(props.correspondenceField)[0]; // Récupère la clé
            const value = props.correspondenceField[key]; // Récupère la valeur
    
            setInputValue({value1:key, value2:value})
        }
    }, [props.correspondenceField])

    function updateCorrespondenceField (isFor,value) {

        let inputVal1 = isFor=='value1' ? value : inputValue.value1
        let inputVal2 = isFor=='value2' ? value : inputValue.value2

        if(currentTimer!=false){
            clearTimeout(timer[currentTimer]) 
        }

        setCurrentTimer(Date.now());

        let tempTimer = setTimeout(() => {
            if(inputValue.value1!='' && inputValue.value2!=''){
                //On modifie l'array de "section1" par exemple
                let newData = [...props.valueCorrespondence]
                newData[props.index] = {[inputVal1]:inputVal2}
    
                //Ici on remplace "section1" par son nouvel array 
                let copySectionCorrespondenceValue = {...props.sectionCorrespondenceValue}
                copySectionCorrespondenceValue['section'+props.numeroSection] = newData
                
                props.setSectionCorrespondenceValue(copySectionCorrespondenceValue)
            }
        }, 1000)
        setTimer({...timer,[Date.now()]:tempTimer})        
    }

    const handleChangeCorrespondenceField = (e,isFor) => {
        setInputValue({...inputValue,[isFor]:e.target.value})

        updateCorrespondenceField(isFor,e.target.value)
    };

    const handleRemoveLine = (indexToRemove) => {
        //On retire la ligne qui correspond à lindex sélectionné
        let newData = [...props.valueCorrespondence]
        newData.splice(indexToRemove,1)

        //On met à jour l'array de "section1" par exemple
        let copySectionCorrespondenceValue = {...props.sectionCorrespondenceValue}
        copySectionCorrespondenceValue['section'+props.numeroSection] = newData
        
        props.setSectionCorrespondenceValue(copySectionCorrespondenceValue)
    };

    return(
        <div className="row mt-2">
            <div className="col-6 form-group">
                <label>{t('correspondenceField')}</label>
                <CorrespondenceFieldInput
                    index={props.index}
                    inputValue={inputValue}
                    handleChangeCorrespondenceField={handleChangeCorrespondenceField}
                    isFor={props.isFor}
                    sectionField={props.sectionField}
                    allClientType={props.allClientType}
                    validButton={props.validButton}
                />
            </div>
            <div className="col-6 form-group">
                <label className='d-flex justify-content-between'>
                    Code
                    {props.index!=0 ? 
                        props.validButton ? <FontAwesomeIcon icon={faTrash} className='text-muted'/> : <FontAwesomeIcon icon={faTrash} className='text-danger pointer' onClick={()=>handleRemoveLine(props.index)}/> 
                    : 
                        false
                    }
                </label>
                <input disabled={props.validButton} value={inputValue.value2} type="text" className='form-control form-control-sm' onChange={(e)=>handleChangeCorrespondenceField(e,'value2')}/>
            </div>
        </div>
    )
}

export default FieldSectionCode;